<mat-icon *ngIf="state === true" color="primary">check</mat-icon>
<mat-icon *ngIf="state === false" color="warn">error</mat-icon>
